import { c as _c } from "react/compiler-runtime";
import { Hint, LanguageCodeEnum } from '@systemeio/ui';
import { CampaignStepInterface } from 'modules/campaigns/campaign-steps/types/campaign-step-interface';
import { getCampaignStepsEditorNextjsUrl } from 'modules/campaigns/campaign-steps/utils/get-campaign-steps-editor-nextjs-url ';
import { CampaignId } from 'modules/campaigns/types/campaign-interface';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { StatusCell } from 'shared/components/table/cells/status-cell';
import { TextWithTooltipCell } from 'shared/components/table/cells/text-with-tooltip-cell';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { formatTimeDuration } from 'shared/utils/format-time-duration';
import { getPercentAndAmountStatistic } from 'shared/utils/get-percent-and-amount-statistic';
import { MailingStatsWrapper } from 'modules/campaigns/campaign-steps/components/mailing-stats-wrapper';
export const useCampaignStepTableColumns = t0 => {
  const $ = _c(64);
  const {
    campaignId
  } = t0;
  const {
    t,
    i18n
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.campaign_step.list.table.header.title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== campaignId) {
    t2 = campaignStep => <LinkWithoutPrefetch className="primary-link whitespace-normal" href={getCampaignStepsEditorNextjsUrl({
      campaignId,
      campaignStepId: campaignStep.id
    })}>{campaignStep.mailing.currentEmail.subject}</LinkWithoutPrefetch>;
    $[2] = campaignId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      key: "name",
      header: t1,
      widthPercent: 30,
      onRender: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("dashboard.campaign_step.list.table.header.tooltip.delay");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("dashboard.campaign_step.list.table.header.delay");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <div className="overflow-hidden"><TextWithTooltipCell wrapperClassName="justify-center">{t5}</TextWithTooltipCell></div>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <div className="overflow-hidden lg:w-full"><Hint className="flex items-center justify-center" label={t4}>{t6}</Hint></div>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== i18n || $[17] !== t) {
    t8 = campaign => <TextWithTooltipCell wrapperClassName="justify-center">{formatTimeDuration(campaign.delayFromPreviousStep || 0, t, i18n.language as LanguageCodeEnum)}</TextWithTooltipCell>;
    $[16] = i18n;
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = {
      key: "delayFromPreviousStep",
      header: t7,
      widthPercent: 8,
      onRender: t8
    };
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t) {
    t10 = t("dashboard.campaign_step.list.table.header.count_subscribed_contacts");
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t) {
    t11 = t("dashboard.campaign_step.list.table.header.contacts");
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11) {
    t12 = {
      key: "contactsCount",
      header: <div className="overflow-hidden lg:w-full"><TextWithTooltipCell mode="hover" label={t10} wrapperClassName="justify-center">{t11}</TextWithTooltipCell></div>,
      widthPercent: 8,
      onRender: _temp
    };
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t) {
    t13 = t("dashboard.campaign_step.list.table.header.emails_sent_count");
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t) {
    t14 = t("dashboard.campaign_step.list.table.header.emails");
    $[31] = t;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t13 || $[34] !== t14) {
    t15 = {
      key: "sentAmount",
      header: <div className="overflow-hidden lg:w-full"><TextWithTooltipCell mode="hover" label={t13} wrapperClassName="justify-center">{t14}</TextWithTooltipCell></div>,
      widthPercent: 8,
      onRender: _temp3
    };
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t) {
    t16 = t("dashboard.campaign_step.list.table.header.number_of_views");
    $[36] = t;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t16) {
    t17 = {
      key: "openedAmount",
      header: <div className="overflow-hidden lg:w-full"><TextWithTooltipCell wrapperClassName="justify-center">{t16}</TextWithTooltipCell></div>,
      widthPercent: 8,
      onRender: _temp5
    };
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t) {
    t18 = t("dashboard.campaign_step.list.table.header.click_count");
    $[40] = t;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t) {
    t19 = t("dashboard.campaign_step.list.table.header.clicks");
    $[42] = t;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== t18 || $[45] !== t19) {
    t20 = {
      key: "totalClicks",
      header: <div className="overflow-hidden lg:w-full"><TextWithTooltipCell mode="hover" label={t18} wrapperClassName="justify-center">{t19}</TextWithTooltipCell></div>,
      widthPercent: 8,
      onRender: _temp7
    };
    $[44] = t18;
    $[45] = t19;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t) {
    t21 = t("dashboard.campaign_step.list.table.header.note");
    $[47] = t;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t21) {
    t22 = {
      key: "note",
      header: <div className="overflow-hidden lg:w-full"><TextWithTooltipCell wrapperClassName="justify-center">{t21}</TextWithTooltipCell></div>,
      widthPercent: 15,
      onRender: _temp8
    };
    $[49] = t21;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== t) {
    t23 = t("global.status");
    $[51] = t;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== t23) {
    t24 = {
      key: "isActive",
      header: <div className="overflow-hidden lg:w-full"><TextWithTooltipCell wrapperClassName="justify-center">{t23}</TextWithTooltipCell></div>,
      widthPercent: 8,
      onRender: _temp9
    };
    $[53] = t23;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  let t25;
  if ($[55] !== t12 || $[56] !== t15 || $[57] !== t17 || $[58] !== t20 || $[59] !== t22 || $[60] !== t24 || $[61] !== t3 || $[62] !== t9) {
    t25 = [t3, t9, t12, t15, t17, t20, t22, t24];
    $[55] = t12;
    $[56] = t15;
    $[57] = t17;
    $[58] = t20;
    $[59] = t22;
    $[60] = t24;
    $[61] = t3;
    $[62] = t9;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  return t25;
};
function _temp(campaignStep_0) {
  return <div className="overflow-hidden lg:w-full"><TextWithTooltipCell wrapperClassName="justify-center">{campaignStep_0.contactsCount}</TextWithTooltipCell></div>;
}
function _temp2(data) {
  return <div className="overflow-hidden lg:w-full"><TextWithTooltipCell wrapperClassName="justify-center">{data.sentAmount}</TextWithTooltipCell></div>;
}
function _temp3(campaignStep_1) {
  return <MailingStatsWrapper data={campaignStep_1.mailingDeliveryStats}>{_temp2}</MailingStatsWrapper>;
}
function _temp4(data_0) {
  return <div className="overflow-hidden lg:w-full"><TextWithTooltipCell wrapperClassName="justify-center">{getPercentAndAmountStatistic({
        numberOfActions: data_0.openedAmount,
        totalNumber: data_0.sentAmount
      })}</TextWithTooltipCell></div>;
}
function _temp5(campaignStep_2) {
  return <MailingStatsWrapper data={campaignStep_2.mailingDeliveryStats}>{_temp4}</MailingStatsWrapper>;
}
function _temp6(data_1) {
  return <div className="overflow-hidden lg:w-full"><TextWithTooltipCell wrapperClassName="justify-center">{getPercentAndAmountStatistic({
        numberOfActions: data_1.clickedAmount,
        totalNumber: data_1.sentAmount
      })}</TextWithTooltipCell></div>;
}
function _temp7(campaignStep_3) {
  return <MailingStatsWrapper data={campaignStep_3.mailingDeliveryStats}>{_temp6}</MailingStatsWrapper>;
}
function _temp8(campaignStep_4) {
  return <TextWithTooltipCell textClassName="whitespace-normal lg:whitespace-nowrap" wrapperClassName="justify-center">{campaignStep_4.note}</TextWithTooltipCell>;
}
function _temp9(campaignStep_5) {
  return <div className="flex items-center justify-center lg:lg:w-full"><StatusCell isActive={campaignStep_5.isActive} /></div>;
}